import React from 'react';
import { Color } from '../../const/Const';
import { Route, Routes } from 'react-router-dom';
import Home from './Home/Home';
import Emp from './Emp/Emp';
import Education from './Education/Education';
import HiredDtl from './HiredDtl/HiredDtl';
import PersonalInformationReport from './Page/PersonalInformationReport';
import FamilyReport from './Page/FamilyReport';
import DisabilityReport from './Page/DisabilityReport';
import SchoolReport from './Page/SchoolReport';
import CertificateReport from './Page/CertificateReport';
import LanguageReport from './Page/LanguageReport';
import HiredReport from './Page/HiredReport';
import SalaryReport from './Page/SalaryReport';
import TerminatedReport from './Page/TerminatedReport';
import ShiftReport from './Page/ShiftReport';
import SalaryChangeReport from './Page/SalaryChangeReport';
import InsuretypeChangeReport from './Page/InsuretypeChangeReport';
import LaborConditionChangedReport from './Page/LaborConditionChangedReport';
import WorkedYear from './Page/WorkedYear';
import SalaryReports from './SalaryReports/SalaryReports';
import TT11Sheet1 from './Page/TT11Sheet1';
import SocialInsurance from './Page/SocialInsurance';

const Report = (props) => {

    return (
        <div style={{ flex: 1, backgroundColor: Color.grayBackground, paddingBottom: 8 }}>
            <Routes>
                <Route path={"/empbasic/emp"} element={<Emp />} />
                <Route path={"/empbasic/emp/personalinformation"} element={<PersonalInformationReport company />} />
                <Route path={"/empbasic/emp/family"} element={<FamilyReport />} />
                <Route path={"/empbasic/emp/disability"} element={<DisabilityReport />} />

                <Route path={"/empbasic/education"} element={<Education />} />
                <Route path={"/empbasic/education/school"} element={<SchoolReport company />} />
                <Route path={"/empbasic/education/certificate"} element={<CertificateReport />} />
                <Route path={"/empbasic/education/language"} element={<LanguageReport />} />

                <Route path={"/hired"} element={<HiredDtl />} />
                <Route path={"/hired/salaryreport"} element={<SalaryReport />} />
                <Route path={"/hired/hiredreport"} element={<HiredReport />} />
                <Route path={"/hired/terminatedreport"} element={<TerminatedReport />} />
                <Route path={"/hired/shiftreport"} element={<ShiftReport />} />
                <Route path={"/hired/salarychangereport"} element={<SalaryChangeReport />} />
                <Route path={"/hired/insuretypechangereport"} element={<InsuretypeChangeReport />} />
                <Route path={"/hired/laborconditionchangedreport"} element={<LaborConditionChangedReport />} />
                <Route path={"/hired/workedyear"} element={<WorkedYear />} />

                <Route path={"/salary"} element={<SalaryReports />} />
                <Route path={"/salary/sheet1"} element={<TT11Sheet1 />} />
                <Route path={"/salary/socialinsurance"} element={<SocialInsurance />} />

                <Route path="/" element={<Home />} />
            </Routes>
        </div >
    );
}

export default Report;